module.exports = __webpack_public_path__ + "img/ACG.49dfe578.png";